<template>
  <div>
    <a-layout-content :style="{ padding: '0 10px', marginTop: '86px' }">
      <div :style="{ background: '#fff', padding: '24px', minHeight: '380px' }">
        <a-spin
          :spinning="spinning"
          :tip="this.$t('ujian.tip')"
          size="large"
          :wrapperClassName="spinstyle"
        >
          <div class="spin-content">
            <a-steps :current="current">
              <a-step
                v-for="item in steps"
                :key="item.title"
                :title="item.title"
              >
                <a-icon slot="icon" :type="item.user" />
              </a-step>
            </a-steps>
            <div class="steps-content">
              <div v-if="current == 0">
                <welcome> </welcome>
              </div>
              <div v-else-if="current === 1">
                <biodata :biodata="biodata"></biodata>
              </div>
              <div v-else-if="current == 2">
                <how-to-use></how-to-use>
              </div>
              <div v-else-if="current == 3">
                <start-ujian
                  :groupsoal="listkategoriujian"
                  :spinning="spinning"
                  @start-loading="startLoading"
                ></start-ujian>
              </div>
            </div>
            <div class="steps-action">
              <a-button
                v-if="current > 0"
                style="margin-right: 8px"
                @click="prev"
              >
                {{ $t("general.button.before") }}
              </a-button>
              <!-- <a-button
        v-if="current == steps.length - 1"
        type="primary"
        @click="$message.success('Processing complete!')"
      >
        {{ $t('general.button.start-examp') }}
      </a-button> -->

              <a-button
                v-if="current < steps.length - 1"
                type="primary"
                @click="next"
              >
                {{ $t("general.button.next") }}
              </a-button>
            </div>
          </div>
        </a-spin>
      </div>
    </a-layout-content>
  </div>
</template>
<script>
import Welcome from "@/views/components/ujian/Welcome.vue";
import Biodata from "@/views/components/ujian/Biodata.vue";
import HowToUse from "@/views/components/ujian/HowToUse.vue";
import StartUjian from "@/views/components/ujian/StartUjian.vue";
// import store from '@/module/store.js'
// import { mapState } from 'vuex'

import { get } from "@/services/api";

export default {
  components: {
    Welcome,
    Biodata,
    HowToUse,
    StartUjian,
  },
  data() {
    return {
      spinning: false,
      spinstyle: "",
      current: 0,
      steps: [
        {
          title: this.$t("ujian.description.welcome"),
          content: Welcome,
          user: "desktop",
        },
        {
          title: this.$t("ujian.description.biodata"),
          content: "Second-content",
          user: "user",
        },
        {
          title: this.$t("ujian.description.how-to-use"),
          content: "Last-content",
          user: "history",
        },
        {
          title: this.$t("ujian.description.start-examp"),
          content: "Last-content",
          user: "check",
        },
      ],
      biodata: {
        name: "",
        address: "",
        mobile: "",
        email: "",
        test_number: "",
        information: "",
        company: "",
        birth: "",
      },
      listkategoriujian: [],
    };
  },
  methods: {
    next() {
      this.current++;
    },
    prev() {
      this.current--;
    },

    //==================================== Getter
    getListGroup() {
      get("UJIAN", "Participant/ListGroup", {
        id_period: this.$store.state.participant.ujian.id_period,
      }).then((response) => {
        let res = response.data;
      
        if (res) {
          this.listkategoriujian = res;
        }
      });
    },

    //==================================== Setter
    startLoading(value) {
      this.spinning = value;
      this.spinstyle = "spin-show";
      this.setMulaiUjian();
    },
    setParticipant() {
      this.biodata.name = this.$store.state.participant.biodata.name;
      this.biodata.address = this.$store.state.participant.biodata.address;
      this.biodata.mobile = this.$store.state.participant.biodata.mobile;
      this.biodata.email = this.$store.state.participant.biodata.email;
      this.biodata.test_number = this.$store.state.participant.biodata.test_number;
      this.biodata.information = this.$store.state.participant.biodata.information;
      this.biodata.company = this.$store.state.participant.company.name;
      this.biodata.birth =
        this.$store.state.participant.biodata.place_of_birth +
        ", " +
        this.$store.state.participant.biodata.date_of_birth;
    },
    setListSoal() {
      get("UJIAN", "Participant/ListSoal", {
        id_period:this.$store.state.participant.ujian.id_period,
        id_participant: this.$store.state.participant.biodata.id,
        }).then((response) => {
          let res = response.data;
          this.$store.commit('setListSoal', res);
          this.$store.commit("setIndexSoal", 0);
          this.$router.push("ujian");
        });
    },
    setMulaiUjian() {
      get("UJIAN", "Participant/CreateSOAL", {
        id_participant: this.$store.state.participant.biodata.id,
      }).then((response) => {
        let res = response.data;
        if (res == 0) {
          this.spinning = false;
          this.spinstyle = "";
          this.$notification["error"]({
            message: this.$t("ujian.error-message.title"),
            description:
              this.$t("ujian.error-message.create-soal") +
              this.$store.state.participant.company.name,
            class: "ant-alert-error",
          });
        } else if (res == 3) {
          this.spinning = false;
          this.spinstyle = "";
          this.$notification["error"]({
            message: this.$t("ujian.error-message.title"),
            description:
              this.$t("ujian.error-message.group-soal") +
              this.$store.state.participant.company.name,
            class: "ant-alert-error",
          });
        } else if (res == 4) {
          this.spinning = false;
          this.spinstyle = "";
          this.$notification["error"]({
            message: this.$t("ujian.error-message.title"),
            description:
              this.$t("ujian.error-message.period-soal") +
              this.$store.state.participant.company.name,
            class: "ant-alert-error",
          });
        } else {
          this.setListSoal();          
        }
      });
    },
  },
  created() {
    if(this.$store.state.participant.ujian.selected_kategori=="")
    {
      this.setParticipant();
      this.getListGroup();
    }
    else
    {
      // this.$store.state.participant.ujian.selected_kategori
      this.$router.push('ujian');      
    }
  },
};
</script>
<style scoped>
.steps-content {
  margin-top: 50px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 300px;
}

.steps-action {
  margin-top: 24px;
}

.spin-content {
  padding: 30px;
}

.spin-show {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
}
</style>
